import { render } from "./general.vue?vue&type=template&id=6109bc1b&scoped=true"
import script from "./general.vue?vue&type=script&lang=js"
export * from "./general.vue?vue&type=script&lang=js"

import "./general.vue?vue&type=style&index=0&id=6109bc1b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6109bc1b"]])

export default __exports__